<template>
  <div class="region-block">
    <div class="region-header">
      <img
        v-if="flag"
        :src="flag"
        alt=""
        class="flag-icon"
      />

      <span class="region-name">
        {{ regionName }}
      </span>
    </div>

    <div class="city-list">
      <CityItem
        v-for="city in cities"
        :key="city._id"
        :city="city"
        :selectedCityId="selectedCityId"
        @select-city="selectCity"
      />
    </div>
  </div>
</template>

<script setup>
import CityItem from "./CityItem.vue";

defineProps({
  regionName: String,
  flag: String,
  cities: Array,
  selectedCityId: String
});

const emit = defineEmits([
  "select-city"
]);

const selectCity = (city) => {
  emit("select-city", city);
};
</script>

<style scoped>
.region-block {
  margin: 0;
  padding: 0 4px 22px;

  border-bottom: 1px solid var(--region-divider);
}

.region-block:last-child {
  padding-bottom: 4px;
  border-bottom: none;
}

.region-header {
  display: flex;
  align-items: center;
  gap: 10px;

  margin-bottom: 14px;

  color: var(--header-text-dark);

  font-family: "Eastman-Bold", sans-serif;
  font-size: 16px;
  line-height: 1.25;
}

[data-theme="light"] .region-header {
  color: var(--header-text-light);
}

.region-name {
  min-width: 0;

  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
}

.flag-icon {
  width: 24px;
  height: 18px;
  flex-shrink: 0;

  object-fit: cover;

  border-radius: 4px;

  box-shadow:
    0 1px 4px rgba(0, 0, 0, 0.16);
}

.city-list {
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding-left: 0;
}

:global(:root) {
  --region-divider: rgba(255, 255, 255, 0.08);
}

:global([data-theme="light"]) {
  --region-divider: rgba(0, 0, 0, 0.08);
}

@media (max-width: 768px) {
  .region-block {
    padding-bottom: 18px;
  }

  .region-header {
    margin-bottom: 12px;

    font-size: 15px;
  }

  .flag-icon {
    width: 22px;
    height: 16px;
  }
}
</style>